import React, { useState, useEffect } from "react";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";

import { Img } from "component/FrameL";
import "./style.css";
import StripeBanner from "assets/stripe-banner.png";

function DesktopNavbar({ CoreData }) {
  const { bookingEngineUrl, hotelLogo, hotelName } = CoreData;
  const [isScrolled, setIsScrolled] = useState(false);

  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar ${isScrolled ? "navbar--scrolled" : ""} ${
        isHome ? "navbar--home" : ""
      }`}
    >
      {/* Expanded navbar (before scroll) */}
      <div
        className={`navbar__expanded ${
          isScrolled ? "navbar__expanded--hidden" : ""
        }`}
      >
        <Link to="/" className="navbar__brand-expanded no-underline">
          <Img className="navbar__logo-expanded" Image={hotelLogo} />
          <span className="navbar__title-expanded">{hotelName}</span>
        </Link>
        <div className="navbar__links-expanded">
          <Link to="/rooms">Rooms</Link>
          <Link to="/specials">Specials</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/dining">Dining</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="navbar__book-btn-expanded-container">
          {bookingEngineUrl && (
            <a
              href={bookingEngineUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="navbar__book-btn-expanded"
            >
              Book Now
            </a>
          )}
        </div>
      </div>

      {/* Compact navbar (after scroll) */}
      <div
        className={`navbar__compact ${
          isScrolled ? "navbar__compact--visible" : ""
        }`}
      >
        <Link to="/" className="navbar__brand-compact no-underline">
          <Img className="navbar__logo-compact" Image={hotelLogo} />
          <span className="navbar__title-compact">{hotelName}</span>
        </Link>

        <div className="navbar__links-compact">
          <Link to="/rooms">Rooms</Link>
          <Link to="/specials">Specials</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/dining">Dining</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="navbar__book-btn-compact">
          {bookingEngineUrl && (
            <a
              href={bookingEngineUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book Now
            </a>
          )}
        </div>
      </div>

      <div
        className={`navbar__stripe ${
          isScrolled ? "navbar__stripe--compact" : ""
        }`}
        style={{ backgroundImage: `url(${StripeBanner})` }}
      />
    </nav>
  );
}

function MobileNavbar({ CoreData }) {
  const { hotelLogo, hotelName, bookingEngineUrl } = CoreData;
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <div className="mobile-nav">
      <div className="mobile-nav__bar">
        <button
          className="mobile-nav__toggle"
          onClick={() => setIsOpen(true)}
          aria-label="Open menu"
        >
          <IoMdMenu className="text-3xl" />
        </button>

        <Link to="/" className="mobile-nav__brand no-underline">
          <Img Image={hotelLogo} className="mobile-nav__logo" />
          <span className="mobile-nav__title">{hotelName}</span>
        </Link>

        {bookingEngineUrl && (
          <a
            href={bookingEngineUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-nav__book-btn"
          >
            Book
          </a>
        )}
      </div>

      {/* Mobile menu overlay */}
      <div
        className={`mobile-nav__overlay ${isOpen ? "visible" : ""}`}
        onClick={closeMenu}
      />

      {/* Mobile menu drawer */}
      <div className={`mobile-nav__drawer ${isOpen ? "visible" : ""}`}>
        <button
          className="mobile-nav__close"
          onClick={closeMenu}
          aria-label="Close menu"
        >
          <IoMdClose className="text-3xl" />
        </button>

        <Link
          to="/"
          onClick={closeMenu}
          className="mobile-nav__drawer-brand no-underline"
        >
          <Img className="mobile-nav__drawer-logo" Image={hotelLogo} />
          <h3>{hotelName}</h3>
        </Link>

        <div className="mobile-nav__drawer-links">
          <Link to="/rooms" onClick={closeMenu}>
            Rooms
          </Link>
          <Link to="/specials" onClick={closeMenu}>
            Specials
          </Link>
          <Link to="/gallery" onClick={closeMenu}>
            Gallery
          </Link>
          <Link to="/dining" onClick={closeMenu}>
            Dining
          </Link>
          <Link to="/explore" onClick={closeMenu}>
            Explore
          </Link>
          <Link to="/about" onClick={closeMenu}>
            About
          </Link>
          <Link to="/contact" onClick={closeMenu}>
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

const NavBar = ({ CoreData }) => {
  return (
    <>
      <div className="desktop-nav-wrapper">
        <DesktopNavbar CoreData={CoreData} />
      </div>
      <MobileNavbar CoreData={CoreData} />
    </>
  );
};

export default NavBar;
